// extracted by mini-css-extract-plugin
module.exports = {"bkw-L":"L_bkw-L__HHpbB"};